import { FormState } from 'informed';
import { useMutation } from 'react-query';
import feathersClient from '../../apiClient';
import getResponseArray from '@tymbe/utils/getResponseArray';
import { ErrorAlert, SuccessAlert } from '../../components/alerts';
import { AdminPopupFormValues, mapLabelValueToValues, useCompaniesWithBranchoffices } from './adminPopupUtils';
import { AdminPopup } from '@tymbe/schema/admin-popup.interface';
import AdminPopupForm from './AdminPopupForm';

interface CreateAdminPopupPageProps {
  onClose?: () => void;
}

export default function CreateAdminPopupPage({ onClose }: CreateAdminPopupPageProps) {
  const { data, isLoading } = useCompaniesWithBranchoffices();
  const companies = getResponseArray(data);
  const fetchMutation = useMutation<AdminPopup>(() => feathersClient.service('admin-popup').find());
  const createMutation = useMutation((data: Partial<AdminPopup>) => feathersClient.service('admin-popup').create(data));

  const handleSubmit = (data: FormState<AdminPopupFormValues>) => {
    const { values: formValues } = data;
    const queryData = {
      ...formValues,
      button_text: formValues.button_text || null,
      from: formValues.from?.startOf('day').toISOString(),
      to: formValues.to?.endOf('day').toISOString(),
      display_frequency_weekday: formValues.display_frequency_weekday
        ? mapLabelValueToValues<number>(formValues.display_frequency_weekday)
        : null,
      company_ids: mapLabelValueToValues<number>(formValues.company_ids),
      show_on_modul_page:
        formValues.show_on_modul_page.length === 0
          ? ['calendar']
          : mapLabelValueToValues<string>(formValues.show_on_modul_page),
    };

    createMutation.mutate(queryData, {
      onSuccess: () => {
        fetchMutation.mutate();
        SuccessAlert('Popup úspěšně vytvořen');
        if (onClose) onClose();
      },
      onError: () => {
        ErrorAlert('Něco se pokazilo... :(');
      },
    });
  };

  return (
    <AdminPopupForm
      title="Vytvořit nový popup"
      mode="create"
      onSubmit={handleSubmit}
      onCancel={onClose}
      companies={companies}
      isLoading={isLoading}
      mutationLoading={createMutation.isLoading}
    />
  );
}
